import React, {Component, PropTypes} from 'react'
import {Row, Col} from 'react-bootstrap'
import i18n from '../i18n'
import style from './TimeRangePicker.less'

function range(start, end) {
    var array = []
    for (var i = start ; i < end ; i++) {
        array[i] = i
    }
    return array
}

function today() {
    var date = new Date()
    date.setHours(0)
    date.setMinutes(0)
    date.setSeconds(0)
    date.setMilliseconds(0)
    return date
}

class TimeRangePicker extends Component {
    static propTypes = {
        value: PropTypes.object,
        onChange: PropTypes.func.isRequired
    }

    _selectFromHour(event) {
        const {value, onChange} = this.props

        const hour = parseInt(event.target.value)
        const previousFrom = value && value.from || today()
        const nextFrom = new Date(previousFrom.getFullYear(), previousFrom.getMonth(), previousFrom.getDate(), hour)
        const nextTo = value.to && (nextFrom < value.to && value.to || nextFrom)        
        const nextValue = {from: nextFrom, to: nextTo}
        onChange(nextValue)
    }

    _selectToHour(event) {
        const {value, onChange} = this.props

        const hour = parseInt(event.target.value)
        const previousTo = value && value.to || today()
        const nextTo = new Date(previousTo.getFullYear(), previousTo.getMonth(), previousTo.getDate(), hour)
        const nextValue = {...value, to: nextTo}
        onChange(nextValue)
    }

    _selectRangeHour(event, start, end) {
        const {value, onChange} = this.props

        event.preventDefault()

        const previousFrom = value && value.from || today()
        const previousTo = value && value.to || today()
        const nextFrom = new Date(previousFrom.getFullYear(), previousFrom.getMonth(), previousFrom.getDate(), start)
        const nextTo = new Date(previousTo.getFullYear(), previousTo.getMonth(), previousTo.getDate(), end)
        const nextValue = {from: nextFrom, to: nextTo}
        onChange(nextValue)
    }

    render() {
        const {value, onChange} = this.props

        const fromHour = value && value.from && value.from.getHours()
        const toHour = value && value.to && value.to.getHours()

        const fromHourRange = range(0, 24)
        const toHourRange = range(fromHour, 24)

        return (
            <div className={style.default}>
                <div className={style.picker}>
                    <select
                        className='form-control'
                        value={fromHour}
                        onChange={(e) => this._selectFromHour(e)}>
                        {(!value || !value.from) && (
                            <option value=''>heure</option>
                        )}
                        {fromHourRange.map((v, i) => (
                            <option
                                key={i}
                                value={v}>
                                {v}
                            </option>
                        ))}
                    </select>
                    <span> > </span>
                    <select
                        className='form-control'
                        value={toHour}
                        onChange={(e) => this._selectToHour(e)}>
                        {(!value || !value.to) && (
                            <option value=''>heure</option>
                        )}
                        {toHourRange.map((v, i) => (
                            <option
                                key={i}
                                value={v}>
                                {v}
                            </option>
                        ))}
                    </select>
                </div>
                <div className={style.preset}>
                    <a
                        href=''
                        onClick={(e) => this._selectRangeHour(e, 9, 12)}>
                        {i18n.morning}
                    </a>
                    <span> | </span>
                    <a
                        href=''
                        onClick={(e) => this._selectRangeHour(e, 14, 18)}>
                        {i18n.afternoon}
                    </a>
                </div>
            </div>
        )
    }
}

export default TimeRangePicker


// WEBPACK FOOTER //
// ./lib/core/components/TimeRangePicker.js